import { render, staticRenderFns } from "./client-loader.vue?vue&type=template&id=24e9a908"
import script from "./client-loader.vue?vue&type=script&lang=js"
export * from "./client-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports